import React, {useCallback, useEffect, useState} from 'react';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import {useMutation} from '@tanstack/react-query';
import {getRebateReport} from '../library/api';

const limitOption = [
    {
        label: '10개 보기',
        value: 10,
    },
    {
        label: '20개 보기',
        value: 20,
    },
    {
        label: '50개 보기',
        value: 50,
    },
    {
        label: '100개 보기',
        value: 100,
    },
];
const SettlementReport = () => {
    const [totalCount, setTotalCount] = useState(20);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(limitOption[0].value);
    const [month, setMonth] = useState(moment(new Date()).format('YYYY-MM'));
    // 정산 리포트
    const {mutate: getRebateReportMutate, data: getRebateReportData} = useMutation({
        mutationFn: getRebateReport,
        mutationKey: ['getRebateReport'],
        onSuccess: data => {
            setTotalCount(data.totalCount);
        },
        onError: error => {
            if (error.response.data.code !== 401) {
                alert(error.response.data.message);
            }
            throw error;
        }
    });

    useEffect(() => {
        handleSubmit();
    }, [limit, page]);
    const handleSubmit = useCallback(() => {
        const items = {
            rebateDt: month,
            startDt: null,
            endDt: null,
            page: page,
            limit: limit
        };

        getRebateReportMutate(items);
    }, [page, limit, month]);
    return (
        <main className="flex-grow container mx-auto px-4 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="sm:text-3xl text-2xl font-bold mb-6">정산 리포트</h1>

                <div className="mb-6">
                    <div
                        className="flex justify-center items-center space-x-2 bg-gray-100 rounded-[15px] md:p-7 p-2 border border-gray-300">
                        <label className="font-bold md:font-base text-sm">정산월</label>
                        <input type="month"
                               className="bg-white md:w-[200PX] border border-gray-300 rounded-[10px] md:px-4 px-2 h-9 outline-none"
                               max={moment(new Date()).format('YYYY-MM')}
                               value={month} onChange={event => {
                            setMonth(event.target.value);
                        }}/>
                        <button type="button" onClick={event => {
                            event.preventDefault();
                            handleSubmit();
                            setPage(1);
                        }}
                                className="bg-gray-800 flex justify-center items-center md:text-base text-sm text-white md:px-7 px-4 h-9 rounded-[10px]">검색
                        </button>
                    </div>
                </div>

                <div className="max-w-6xl mx-auto">
                    <div className="mb-4 flex gap-x-2 items-center">
                        <h2 className="text-sm font-medium">총 <span className="text-teal-500">{totalCount}</span>건
                        </h2>
                        <select className="border rounded-[10px] h-9 px-2 pr-14 text-sm cursor-pointer"
                                onChange={event => {
                                    setLimit(Number(event.target.value));
                                    setPage(1);
                                }}>

                            {
                                limitOption?.map((e, i) => (
                                    <option key={e.value} value={e.value}>{e.label}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className="overflow-x-auto bg-white border-t-2 border-teal-500">
                        <table className="w-full table-auto">
                            <thead>
                            <tr className="border-b border-gray-200">
                                <th className="py-5 px-4 border-r border-gray-200 text-center text-sm font-bold text-[#333] whitespace-nowrap">가입
                                    고객명
                                </th>
                                <th className="py-5 px-4 border-r border-gray-200 text-center text-sm font-bold text-[#333] whitespace-nowrap">고객
                                    등급
                                </th>
                                <th className="py-5 px-4 border-r border-gray-200 text-center text-sm font-bold text-[#333] whitespace-nowrap">일시
                                    서비스 수수료
                                </th>
                                <th className="py-5 px-4 border-r border-gray-200 text-center text-sm font-bold text-[#333] whitespace-nowrap">파트너
                                    수익금액
                                </th>
                                <th className="py-5 px-4 border-r border-gray-200 text-center text-sm font-bold text-[#333] whitespace-nowrap">고객사
                                    정산일자
                                </th>
                                <th className="py-5 px-4 text-center text-sm font-bold text-[#333] whitespace-nowrap">지급일</th>
                            </tr>
                            </thead>
                            <tbody className="text-gray-600 text-sm">
                            {
                                getRebateReportData?.totalCount !== 0 ? getRebateReportData?.list?.map((e, i) => (
                                    <tr className="border-b border-gray-200" key={e.corp_seq}>
                                        <td className="py-5 border-r border-gray-200 px-4 text-left  whitespace-nowrap">{e.corp_nm}</td>
                                        <td className="py-5 border-r border-gray-200 px-4 text-center  whitespace-nowrap">{e.plan_nm}</td>
                                        <td className="py-5 border-r border-gray-200 px-4 text-right  whitespace-nowrap">₩ {(e.fee_amt).toLocaleString()}</td>
                                        <td className="py-5 border-r border-gray-200 px-4 text-right  whitespace-nowrap">₩ {(e.pay_amt).toLocaleString()}</td>
                                        <td className={`py-5 border-r border-gray-200 px-4 text-center  whitespace-nowrap ${!e.done_dt && 'text-red-500'}`}>{!e.done_dt ? '미정산' : moment.utc(e.done_dt).format('YYYY.MM.DD')}</td>
                                        <td className="py-5 px-4 text-center  whitespace-nowrap">{e.pay_yn === 'Y' ? moment.utc(e.pay_dt).format('YYYY.MM.DD') : ''}</td>
                                    </tr>
                                )) : <tr className="border-b border-gray-200 text-red-500">
                                    <td colSpan="6" className="text-center h-[200px]   font-[700] text-[14px]">정산
                                        내역이
                                        없습니다
                                    </td>
                                </tr>
                            }

                            </tbody>
                        </table>
                    </div>

                    <div
                        className="md:mb-[200px] mb-[80px] mt-4 flex flex-col justify-between text-xs text-gray-400">
                        <p className="mb-2 sm:mb-0">
                            · 수익금액 지급은 가입 고객의 일사 서비스 수수료가 일사에 정산 완료된 후 지급됩니다.
                            <br/>
                            · 제비용(세금 포함)은 원천징수 후 차액만 지급됩니다.
                        </p>

                        <Pagination
                            prevPageText={(<img src="/assets/prev.svg"/>)}
                            nextPageText={(<img src="/assets/next.svg"/>)}
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalCount === 0 ? 1 : totalCount}
                            pageRangeDisplayed={5}
                            hideFirstLastPages={true}
                            onChange={(e) => setPage(e)}
                        />
                    </div>
                </div>
            </div>
        </main>
    );
};

export default SettlementReport;
